export default "__VITE_ASSET__CMhbyQOR__"